import S from "./index.module.scss";
import Block, { BlockType } from "@/components/ui/info-blocks/block";
import { FC } from "react";

interface IInfoBlocks {
  blocks: BlockType[];
}

const InfoBlocks: FC<IInfoBlocks> = ({ blocks }) => {
  return (
    <div className={S.socialList}>
      {blocks.map((social, idx) => (
        <Block block={social} key={idx} />
      ))}
    </div>
  );
};

export default InfoBlocks;
